import ApiService from "@/common/api.service";
import {
    FETCH_DECORATION_TEMPLATE,
    FETCH_DECORATION_PRICES,
    FETCH_ALL_DECORATION_TEMPLATES
} from "./actions.type";
import {
    FETCH_START_DECORATION_PRICES,
    FETCH_END_DECORATION_PRICES,
    FETCH_START_DECORATION_TEMPLATE,
    FETCH_END_DECORATION_TEMPLATE,
    FETCH_START_ALL_DECORATION_TEMPLATES,
    FETCH_END_ALL_DECORATION_TEMPLATES
} from "./mutations.type";

const state = {
    printTemplates: [],
    embroideryTemplates: [],
    patchTemplates: [],
    decorationTemplate: null,
    decorationPrices: null,
    isLoading: true
};

const getters = {
    decorationTemplate(state) {
        return state.decorationTemplate;
    },
    decorationPrices(state) {
        return state.decorationPrices;
    },
    printTemplates(state) {
        return state.printTemplates;
    },
    embroideryTemplates(state) {
        return state.embroideryTemplates;
    },
    patchTemplates(state) {
        return state.patchTemplates;
    },
    isLoading(state) {
        return state.isLoading;
    },
    getSingleLocation:
        (state) => (quantity, decoration_type, decoration_prices) => {
            let qty_wise_color_price = 0;
            if (decoration_type == 1) {
                let decoration_data = decoration_prices.print_location1;
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity <= quantity || index == 0) {
                        qty_wise_color_price = element.colour1;
                    }
                }
            } else if (decoration_type == 2 || decoration_type == 4) {
                for (const [index, element] of Object.entries(
                    decoration_prices
                )) {
                    if (index == 0) {
                        if (element.quantity1 > quantity) {
                            qty_wise_color_price = parseFloat(element.cost);
                            break;
                        }
                    }
                    if (element.quantity1 <= quantity) {
                        if (element.quantity2 >= quantity) {
                            qty_wise_color_price = parseFloat(element.cost);
                            break;
                        }
                    }
                }
            } else if (decoration_type == 3) {
                for (const [index, element] of Object.entries(
                    state.decorationPrices
                )) {
                    if (element.quantity <= quantity || index == 0) {
                        qty_wise_color_price = parseFloat(element.cost);
                    }
                }
            }

            return qty_wise_color_price;
        }
};

const actions = {
    [FETCH_DECORATION_PRICES]({ commit }, params) {
        commit(FETCH_START_DECORATION_PRICES);
        if (params.decoration_type == 1) {
            return new Promise((resolve) => {
                ApiService.get(
                    `printtemplateproductforlocations/${params.decoration_price_template_id}`
                )
                    .then(({ data }) => {
                        commit(FETCH_END_DECORATION_PRICES, data);
                        resolve(data);
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            });
        } else if (params.decoration_type == 2 || params.decoration_type == 4) {
            return new Promise((resolve) => {
                const endpoint =
                    params.decoration_type == 4
                        ? `patch-application-template/${params.decoration_price_template_id}`
                        : `embroiderytemplate/${params.decoration_price_template_id}`;
                ApiService.get(endpoint)
                    .then(({ data }) => {
                        commit(
                            FETCH_END_DECORATION_PRICES,
                            data["em_template_data"]
                        );
                        resolve(data);
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            });
        } else {
            return new Promise((resolve) => {
                ApiService.get(
                    `promotemplateproduct/${params.decoration_price_template_id}`
                )
                    .then(({ data }) => {
                        commit(
                            FETCH_END_DECORATION_PRICES,
                            data["product_list"]
                        );
                        resolve(data);
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            });
        }
    },
    [FETCH_DECORATION_TEMPLATE]({ commit }, params) {
        commit(FETCH_START_DECORATION_TEMPLATE);
        if (params.decoration_type == 1) {
            return new Promise((resolve) => {
                ApiService.get(
                    `printtemplate/${params.decoration_price_template_id}`
                )
                    .then(({ data }) => {
                        commit(
                            FETCH_END_DECORATION_TEMPLATE,
                            data.templatedetail
                        );
                        resolve(data);
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            });
        } else if (params.decoration_type == 2 || params.decoration_type == 4) {
            return new Promise((resolve) => {
                const endpoint =
                    params.decoration_type == 4
                        ? `patch-application/${params.decoration_price_template_id}`
                        : `embroidery/${params.decoration_price_template_id}`;
                ApiService.get(endpoint)
                    .then(({ data }) => {
                        commit(
                            FETCH_END_DECORATION_TEMPLATE,
                            params.decoration_type == 4
                                ? data.patch_application_detail
                                : data.embroiderydetail
                        );
                        resolve(data);
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            });
        } else {
            return new Promise((resolve) => {
                ApiService.get(
                    `protemplate/${params.decoration_price_template_id}`
                )
                    .then(({ data }) => {
                        commit(
                            FETCH_END_DECORATION_TEMPLATE,
                            data.promo_template_data
                        );
                        resolve(data);
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            });
        }
    },
    [FETCH_ALL_DECORATION_TEMPLATES]({ commit }) {
        commit(FETCH_START_ALL_DECORATION_TEMPLATES);
        return new Promise((resolve) => {
            ApiService.get(`get-all-decoration-templates`)
                .then(({ data }) => {
                    commit(FETCH_END_ALL_DECORATION_TEMPLATES, data);
                    resolve(data);
                })
                .catch((error) => {
                    throw new Error(error);
                });
        });
    }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [FETCH_START_DECORATION_PRICES](state) {
        state.isLoading = true;
    },
    [FETCH_END_DECORATION_PRICES](state, data) {
        state.decorationPrices = data;
        state.isLoading = false;
    },
    [FETCH_START_DECORATION_TEMPLATE](state) {
        state.isLoading = true;
    },
    [FETCH_END_DECORATION_TEMPLATE](state, data) {
        state.decorationTemplate = data;
        state.isLoading = false;
    },
    [FETCH_START_ALL_DECORATION_TEMPLATES](state) {
        state.isLoading = false;
    },
    [FETCH_END_ALL_DECORATION_TEMPLATES](state, data) {
        state.printTemplates = data.print_templates;
        state.embroideryTemplates = data.embroidery_templates;
        state.patchTemplates = data.patch_application_templates || [];
        state.isLoading = false;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
